// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"f9eb6623","453":"2d7a9d58","876":"38d0726e"}[chunkId] + ".chunk.js";
};